import React, { useEffect, useState } from "react";
import { Text, StyleSheet, View, Platform } from "react-native";

import {
  getStorageItem,
  getStorageKey,
  navigate,
  setStorageItem,
} from "../../../../../helpers/utils";
import cardStyles from "../cardStyles";
import appStyles from "../../../../appStyles";
import AppTheme from "../../../AppTheme";
import ManaButton from "../../../common/ManaButton";
import CloseIcon from "../../../common/dialog/CloseIcon";
import ImageComponent from "../../../common/ImageComponent";
import appPages from "../../../../../appPages";
import { INTEGRATION_KEYS } from "../../../integrations/IntegrationsHelper";

export default function GenericIntegrationCard({
  controller,
  integrationType = "calendar",
  integrationStep = 1,
  IconTag,
  icon,
  title,
  description,
}) {
  const [showCard, setShowCard] = useState(true);
  const storageKey = `card:${integrationType}_integration`;
  const prefKey = `show_${integrationType}_integration_card`;

  useEffect(() => {
    getStorageItem(getStorageKey(controller, storageKey)).then((data) => {
      const isEnabled = (controller.state?.settings?.testing_preferences || {})[
        prefKey
      ];
      if (data && !data.show && !isEnabled) {
        setShowCard(false);
      }
    });
  }, [controller.state?.settings]);

  const skipSetup = () => {
    controller.tracking.track(`Skip ${integrationType} integration setup`);
    hideCard();
  };

  setup = () => {
    // 2022.01.14: CTA: Setup now - desktop flow as if coming from integrations home
    if (integrationType == INTEGRATION_KEYS.desktop) {
      return navigate(
        controller,
        `integrations_${integrationType}`,
        "changepage",
        {
          isActive: false,
        },
      );
    }

    navigate(controller, appPages.integrationsOnboarding, "changePage", {
      isFromCard: true,
      step: integrationStep,
    });
  };

  const hideCard = () => {
    setShowCard(false);
    setStorageItem(getStorageKey(controller, storageKey), {
      show: false,
    });
  };

  return !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 98, height: "auto" }]}>
        <CloseIcon onPress={hideCard} style={cardStyles.closeButton} />

        <View style={appStyles.row}>
          {IconTag ? (
            <IconTag width={80} height={80} style={{ marginRight: 9 }} />
          ) : (
            <ImageComponent
              image={icon}
              style={{ width: 80, height: 80, marginRight: 9 }}
            />
          )}

          <View style={styles.content}>
            <View>
              <Text style={styles.title}>{title}</Text>
              <Text style={styles.description}>{description}</Text>
            </View>

            <View style={styles.buttons}>
              <ManaButton
                onPress={skipSetup}
                style={[styles.button, { marginRight: 6 }]}
                styleText={styles.buttonText}
                text="I don't want insights"
              />
              <ManaButton
                isMainButton
                onPress={setup}
                style={styles.button}
                styleText={styles.buttonText}
                text="Setup now"
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
    minHeight: 80,
    justifyContent: "space-between",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  button: {
    width: "auto",
    paddingHorizontal: 10,
    borderRadius: 6,
    minWidth: 124,
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
